import React from 'react';
import './Loader.css';

const Loader = () => {
  return (
    <>
      <center>
        <div className="loader" id="loader1"></div>
        <div className="loader" id="loader2"></div>
        <div className="loader" id="loader3"></div>
        <div className="loader" id="loader4"></div>

        <span id="text">LOADING...</span>
      </center>
    </>
  );
};

export default Loader;
